const context = require.context('.', true, /route.js$/)
const routes = context.keys().map((path) => {
    return require(`${path}`).default
})

export default routes
